import trackingApiClient from './trackingApiClient';
import type {
  LocationUserListResponse,
  LocationUserListParams,
  LocationUserInsertItem,
  LocationUserInsertResponse,
  LocationUserStatusUpdate,
  LocationUser,
} from '../types/locationUser';

const ENDPOINT = '/user';

export const locationUserService = {
  /**
   * List users stored in the location module's DB.
   * GET /backoffice/user
   */
  async getUsers(params: LocationUserListParams = {}): Promise<LocationUserListResponse> {
    const { data } = await trackingApiClient.get<LocationUserListResponse>(ENDPOINT, { params });
    return data;
  },

  /**
   * Bulk insert users into the location module from MIS format.
   * POST /backoffice/user
   */
  async insertUsers(users: LocationUserInsertItem[]): Promise<LocationUserInsertResponse> {
    const { data } = await trackingApiClient.post<LocationUserInsertResponse>(ENDPOINT, users);
    return data;
  },

  /**
   * Update a single user's location status (Active/Inactive).
   * PUT /backoffice/user
   */
  async updateUserStatus(update: LocationUserStatusUpdate): Promise<LocationUser> {
    const { data } = await trackingApiClient.put<LocationUser>(ENDPOINT, update);
    return data;
  },
};
